import React from 'react'
import ClassNames from 'classnames';
import Container from '../Container'
function FlexContainer(props) {
    return <Container {...props} className={ClassNames('Container__wrapper_flex', props.className)} />
}

export default FlexContainer
